var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { PstParserService } from 'pst/services';
import { PstScreenValidAction, UserEnteredValueAction, UserSelectedChildNodeAction } from 'pst/store';
import * as fromPst from 'pst/store/pst.store';
import { combineLatest } from 'rxjs';
import { BigNumberPipe } from 'shared/pipes';
import { LoggerService, LookupDataService } from 'shared/services';
import { bigNumberMaxValidator, bigNumberMinValidator } from 'shared/validators';
import { BasePstComponent } from '../base-pst.component';
var CurrencyComponent = /** @class */ (function (_super) {
    __extends(CurrencyComponent, _super);
    function CurrencyComponent(loggerService, modalService, pstStore, pstParser, formBuilder, bigNumberPipe, lookupService) {
        var _this = _super.call(this, loggerService, modalService) || this;
        _this.pstStore = pstStore;
        _this.pstParser = pstParser;
        _this.formBuilder = formBuilder;
        _this.bigNumberPipe = bigNumberPipe;
        _this.lookupService = lookupService;
        _this.max = 1000000;
        _this.noMaxValue = false;
        _this.overrideMax = null;
        _this.min = 1;
        _this.step = 100;
        _this.sliderValue = 0;
        _this.vertical = false;
        return _this;
    }
    CurrencyComponent.prototype.ngOnInit = function () {
        var _this = this;
        var result$ = this.pstStore.select(fromPst.selectInProgressPst);
        var tree$ = this.pstStore.select(fromPst.selectPstTree);
        var tooltips$ = this.lookupService.getPstTooltips();
        combineLatest(result$, tree$, tooltips$, function (result, tree, tooltips) {
            return { result: result, tree: tree, tooltips: tooltips };
        })
            .pipe(this.scavenger.collect())
            .subscribe(function (_a) {
            var result = _a.result, tree = _a.tree, tooltips = _a.tooltips;
            _this.tree = tree;
            if (!_this.tree) {
                return;
            }
            _super.prototype.initContent.call(_this, null, tooltips, tree.node.nodeId);
            var childNode = tree.childNodes[0];
            _this.pstStore.dispatch(new UserSelectedChildNodeAction(childNode));
            _this.heading = _this.pstParser.parseParameterizedString(tree.node.nodeHeading, result);
            _this.description = tree.node.nodeDescription;
            _this.sliderText = _this.pstParser.buildInputDescription(childNode.nodeDescription);
            var range = _this.pstParser.extractRange(childNode.nodeLongDescription);
            _this.overrideMax = _this.pstParser.extractMaxOverride(childNode.nodeLongDescription);
            if (range) {
                if (isNaN(range[1])) {
                    if (_this.overrideMax) {
                        _this.noMaxValue = true;
                        _this.min = range[0] === null ? 1 : range[0];
                    }
                    else {
                        _this.noMaxValue = false;
                    }
                }
                else {
                    _this.min = range[0], _this.max = range[1];
                }
            }
            _this.inputWidth = _this.calculatInputWidth();
            _this.defaultValue = _this.pstParser.extractDefaultValue(tree.node.nodeLongDescription) || '';
            _this.createForm();
            _this.pstStore.dispatch(new PstScreenValidAction(_this.inputForm.valid));
        });
    };
    CurrencyComponent.prototype.ngOnDestroy = function () { };
    CurrencyComponent.prototype.calculatInputWidth = function () {
        return _super.prototype.measureTextWidth.call(this, this.bigNumberPipe.transform(this.noMaxValue ? '1 000 000' : this.max)) + "px";
    };
    CurrencyComponent.prototype.sliderMove = function (event) {
        this.inputForm.controls.value.setValue(this.bigNumberPipe.transform(event.value));
    };
    CurrencyComponent.prototype.createForm = function () {
        var _this = this;
        if (!this.inputForm) {
            var validators = [Validators.required, Validators.pattern('^[0-9\\s]+$'), bigNumberMinValidator(this.min)];
            if (!this.noMaxValue) {
                validators.push(bigNumberMaxValidator(this.max));
            }
            this.inputForm = this.formBuilder.group({
                value: ['', Validators.compose(validators)],
            });
            this.inputForm.valueChanges.subscribe(function (changes) {
                if (changes.value === null || changes.value === '') {
                    _this.sliderValue = 0;
                }
                else {
                    _this.sliderValue = +_this.bigNumberPipe.parse(changes.value);
                }
                _this.pstStore.dispatch(new UserEnteredValueAction(changes.value.replace(/\s/g, '')));
                _this.pstStore.dispatch(new PstScreenValidAction(_this.inputForm.valid));
                var newWidth = _super.prototype.measureTextWidth.call(_this, _this.bigNumberPipe.transform(changes.value));
                if (newWidth > +_this.inputWidth.replace('px', '')) {
                    _this.inputWidth = newWidth + "px";
                }
            });
        }
        if (this.defaultValue) {
            this.inputForm.get('value').setValue(+this.defaultValue);
        }
    };
    return CurrencyComponent;
}(BasePstComponent));
export { CurrencyComponent };
